import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useMemo } from 'react';
import { ExpenseReport_ExpenseReportStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
import { BudgetStatementsStatus } from '../budget-statements-status/budget-statements-status';
interface BudgetStatusBudgetProps {
  status: ExpenseReport_ExpenseReportStatus[];
  setStatus: (scopes: ExpenseReport_ExpenseReportStatus[]) => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}
const statusOptions: Option[] = [{
  value: ExpenseReport_ExpenseReportStatus.Draft,
  label: <BudgetStatementsStatus status={ExpenseReport_ExpenseReportStatus.Draft} />,
  group: 'Status'
}, {
  value: ExpenseReport_ExpenseReportStatus.Final,
  label: <BudgetStatementsStatus status={ExpenseReport_ExpenseReportStatus.Final} />,
  group: 'Status'
}, {
  value: ExpenseReport_ExpenseReportStatus.Review,
  label: <BudgetStatementsStatus status={ExpenseReport_ExpenseReportStatus.Review} />,
  group: 'Status'
}];
function StatusSelectBudget(t0) {
  const $ = _c(13);
  const {
    status,
    setStatus,
    className,
    isLoading,
    disabled
  } = t0;
  let t1;
  if ($[0] !== status) {
    t1 = statusOptions.filter(option => status.includes(option.value as ExpenseReport_ExpenseReportStatus));
    $[0] = status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedOptions = t1;
  let t2;
  if ($[2] !== setStatus) {
    t2 = options => {
      const values = options.map(_temp);
      setStatus(values);
    };
    $[2] = setStatus;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleChange = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("bg-background dark:bg-background");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className) {
    t4 = {
      className
    };
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== disabled || $[8] !== handleChange || $[9] !== isLoading || $[10] !== selectedOptions || $[11] !== t4) {
    t5 = <MultipleSelector value={selectedOptions} onChange={handleChange} options={statusOptions} enableSearch={false} groupBy="group" enableSelectAll={true} selectAllGroup="Status" placeholder="Status" className={t3} commandProps={t4} customItemRenderer={_temp2} isLoading={isLoading} disabled={disabled} />;
    $[7] = disabled;
    $[8] = handleChange;
    $[9] = isLoading;
    $[10] = selectedOptions;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(option_1) {
  return option_1.label;
}
function _temp(option_0) {
  return option_0.value as ExpenseReport_ExpenseReportStatus;
}
function StatusSelectDrawer(t0) {
  const $ = _c(5);
  const {
    status,
    setStatus
  } = t0;
  let t1;
  if ($[0] !== setStatus) {
    t1 = values => {
      setStatus(values as ExpenseReport_ExpenseReportStatus[]);
    };
    $[0] = setStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== handleChange || $[3] !== status) {
    t2 = <DrawerSelect value={status} onChange={handleChange} label="Status" options={statusOptions} multiselect={true} enableSelectAll={true} selectAllLabel="Select All" />;
    $[2] = handleChange;
    $[3] = status;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { StatusSelectBudget, StatusSelectDrawer };